import React, { Component } from "react";
import "moment/locale/id.js";
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBCard,
  MDBCardBody,
  MDBBtn,
} from "mdbreact";
import Select from "react-select";

class Pendaftaran extends Component {
  constructor(props) {
    super(props);

    this.state = {
      CB_JALUR: "",
      val_jalur: "",
      valueOption: {}
    };
  }

  componentDidMount() {

    fetch(global.variable.LINK_API + "student/list", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + global.cookies.get("access_token"),
      },
      body: JSON.stringify({
        'flow_id': 'VPD',
      })
    })
      .then((response) => response.json())
      .then((resData) => {
        if (resData.code === 200) {
          this.setState({ CB_JALUR: resData.data });
        } else {
          global.swal('Info', resData.message, 'info');
        }
      });

    fetch(global.variable.LINK_API + 'auth/parameter', {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + global.cookies.get("access_token"),
      },
      //body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((resData) => {
        if (resData.message === "Success") {
          localStorage.setItem("DATA_PARAMETER", JSON.stringify(resData.data));
        }
      });
  }

  createSelectItems() {
    let items = [];
    for (let i = 0; i < this.state.CB_JALUR.length; i++) {
      items.push(
        {
          value: this.state.CB_JALUR[i].registration_id + " - " + this.state.CB_JALUR[i].fullname,
          label: this.state.CB_JALUR[i].registration_id + " - " + this.state.CB_JALUR[i].fullname
        }
      );
    }
    return <Select options={items} onChange={this.onDropdownSelected2.bind(this)} placeholder="- Pilih Siswa -" />;
  }

  onDropdownSelected2(e) {
    this.setState({ valueOption: e.value });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    localStorage.setItem("DATA_JALUR", this.state.valueOption);
    localStorage.setItem("IS_OFFLINE", 0);

    if (this.state.valueOption.length === 0) {
      global.swal("Info", "Harap pilih siswa", "info");
    } else {
      localStorage.removeItem("reg1");
      localStorage.removeItem("reg2");
      localStorage.removeItem("reg3");
      localStorage.removeItem("reg4");
      localStorage.removeItem("statereg4");
      localStorage.removeItem("reg5");
      localStorage.removeItem("reg6");
      localStorage.removeItem("reg7");
      this.props.history.push("/pendaftaran1");
    }
  };

  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="divContainter">
                  <form onSubmit={this.handleSubmit}>
                    <MDBCard className="mb-5">
                      <MDBCardBody>
                        <MDBBreadcrumb color="cyan lighten-4">
                          <MDBBreadcrumbItem active>
                            <a href="/home">Home</a>
                          </MDBBreadcrumbItem>
                          <MDBBreadcrumbItem active>Pengisian Data Calon Siswa</MDBBreadcrumbItem>
                        </MDBBreadcrumb>
                        <label htmlFor="exampleForm2">Nama Calon Siswa</label>
                        {this.createSelectItems()}
                      </MDBCardBody>
                    </MDBCard>

                    <MDBBtn color="primary" block type="submit">
                      Lanjut
                    </MDBBtn>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Pendaftaran;
